// Start:: Importing Middleware
import auth from "../middleware/auth.js";
import Authentication from "../pages/Authentication.vue";
// End:: Importing Middleware

// Start:: Importing Router Components
import Vue from "vue";
import VueRouter from "vue-router";
// End:: Importing Router Components

// ============== Start:: Home Page Route
import AppContentWrapper from "../pages/AppContentWrapper.vue";
import HomePage from "../pages/HomePage.vue";
// ============== End:: Home Page Route

// ============== Start:: Roles Routes
import RolesHome from "../views/Cruds/Roles/Home.vue";
import AllRoles from "../views/Cruds/Roles/ShowAll.vue";
import EditRole from "../views/Cruds/Roles/Edit.vue";
import CreateRole from "../views/Cruds/Roles/Create.vue";
// ============== End:: Roles Routes

// ============== Start:: Financial Reports Routes
import FinancialReportsHome from "../views/Cruds/FinancialReports/Home.vue";
import AllFinancialReports from "../views/Cruds/FinancialReports/ShowAll.vue";
import ShowFinancialReport from "../views/Cruds/FinancialReports/Show.vue";
// ============== End:: Financial Reports Routes

// ============== Start:: FinancialfinshedReports Routes
import FinancialFinshedReportsHome from "../views/Cruds/FinancialFinshedReports/Home.vue";
import AllFinancialFinshedReports from "../views/Cruds/FinancialFinshedReports/ShowAll.vue";
import ShowFinancialFinshedReport from "../views/Cruds/FinancialFinshedReports/Show.vue";
// ============== End:: FinancialfinshedReports Routes

// ============== Start:: FinancialOrders Routes
import FinancialOrdersHome from "../views/Cruds/FinancialOrders/Home.vue";
import AllFinancialOrders from "../views/Cruds/FinancialOrders/ShowAll.vue";
// ============== End:: FinancialOrders Routes

// ============== Start:: Subscriptions Routes
import SubscriptionsHome from "../views/Cruds/Subscriptions/Home.vue";
import AllSubscriptions from "../views/Cruds/Subscriptions/ShowAll.vue";
// ============== End:: Subscriptions Routes

// ============== Start:: AppRates Routes
import AppRatesHome from "../views/Cruds/AppRates/Home.vue";
import AllAppRates from "../views/Cruds/AppRates/ShowAll.vue";
// ============== End:: AppRates Routes

// ============== Start:: StoreRates Routes
import StoreRatesHome from "../views/Cruds/StoreRates/Home.vue";
import AllStoreRates from "../views/Cruds/StoreRates/ShowAll.vue";
// ============== End:: StoreRates Routes

// ============== Start:: Admins Routes
import ShowAdmin from "../views/Cruds/Admins/Show.vue";
import EditAdmin from "../views/Cruds/Admins/Edit.vue";
import CreateAdmin from "../views/Cruds/Admins/Create.vue";
import AllAdmins from "../views/Cruds/Admins/ShowAll.vue";
import AdminsHome from "../views/Cruds/Admins/Home.vue";
// ============== End:: Admins Routes

// ============== Start:: login Routes
import LoginForm from "../views/Auth/LoginForm.vue";
import ResetPasswordEmailForm from "../views/Auth/ResetPasswordEmailForm.vue";
import EmailVerificationForm from "../views/Auth/EmailVerificationForm.vue";
import ChangePhoneNumberForm from "../views/Auth/ChangePhoneNumber.vue";
import ResetPasswordForm from "../views/Auth/ResetPasswordForm.vue";
// ============== End:: login Routes

// ============== Start:: Contact Messages Routes
import ContactMessagesHome from "../views/Cruds/ContactMessages/Home.vue";
import AllContactMessages from "../views/Cruds/ContactMessages/ShowAll.vue";
import showMessage from "../views/Cruds/ContactMessages/Show.vue";
// ============== End:: Contact Messages Routes

// ============== Start:: App Content Routes
import AppContentHome from "../views/Cruds/AppContent/Home.vue";
import GeneralSettings from "../views/Cruds/AppSettings/GeneralSettings.vue";
import ContactUs from "../views/Cruds/AppContent/ContactUs.vue";
import AboutUsClient from "../views/Cruds/AppContent/AboutUsClient.vue";
import AboutUsProvider from "../views/Cruds/AppContent/AboutUsProvider.vue";
import TermsClient from "../views/Cruds/AppContent/TermsClient.vue";
import TermsProvider from "../views/Cruds/AppContent/TermsProvider.vue";
import DeleteAccount from "../views/Cruds/AppContent/DeleteAccount.vue";
import PrivacyPolicyClient from "../views/Cruds/AppContent/PrivacyPolicyClient.vue";
import PrivacyPolicyProvider from "../views/Cruds/AppContent/PrivacyPolicyProvider.vue";
// ============== End:: App Content Routes

// Start:: faqs Router Components
import FAQSHome from "../views/Cruds/FAQ/Home.vue";
import AllFAQS from "../views/Cruds/FAQ/ShowAll.vue";
import CreateFAQS from "../views/Cruds/FAQ/Create.vue";
import EditFAQS from "../views/Cruds/FAQ/Edit.vue";
import ShowFAQS from "../views/Cruds/FAQ/Show.vue";
// End:: faqs Router Components

// ============ Start:: Users Routes
import UsersHome from "../views/Cruds/Users/Home.vue";
import AllUsers from "../views/Cruds/Users/ShowAll.vue";
import ShowUsers from "../views/Cruds/Users/Show.vue";
// ============ End:: Users Routes

// ============ Start:: Games Routes
import GamesHome from "../views/Cruds/Games/Home.vue";
import AllGames from "../views/Cruds/Games/ShowAll.vue";
import ShowGames from "../views/Cruds/Games/Show.vue";
// ============ End:: Games Routes

// ============== Start:: Companies Requests Routes
import CompaniesRequestsHome from "../views/Cruds/CompaniesRequests/Home.vue";
import AllCompaniesRequests from "../views/Cruds/CompaniesRequests/ShowAll.vue";
import ShowCompaniesRequests from "../views/Cruds/CompaniesRequests/Show.vue";
// ============== End:: Companies Requests Routes

// ============== Start:: Ads Routes
import AdsHome from "../views/Cruds/Ads/Home.vue";
import AllAds from "../views/Cruds/Ads/ShowAll.vue";
import CreateAds from "../views/Cruds/Ads/Create.vue";
import ShowAds from "../views/Cruds/Ads/Show.vue";
import EditAds from "../views/Cruds/Ads/Edit.vue";
// ============== End:: Ads Routes
// ============== Start:: Advertisement Routes
import AdvertisementHome from "../views/Cruds/Advertisement/Home.vue";
import AllAdvertisement from "../views/Cruds/Advertisement/ShowAll.vue";
import CreateAdvertisement from "../views/Cruds/Advertisement/Create.vue";
import ShowAdvertisement from "../views/Cruds/Advertisement/Show.vue";
// import EditAdvertisement from "../views/Cruds/Advertisement/Edit.vue";
// ============== End:: Advertisement Routes
// ============== Start:: Companies Routes
import CompaniesHome from "../views/Cruds/Companies/Home.vue";
import AllCompanies from "../views/Cruds/Companies/ShowAll.vue";
import CreateCompanies from "../views/Cruds/Companies/Create.vue";
import ShowCompany from "../views/Cruds/Companies/Show.vue";
import EditCompanies from "../views/Cruds/Companies/Edit.vue";
// ============== End:: Advertisement Routes
// ============== Start:: Products Routes
import ProductsHome from "../views/Cruds/Products/Home.vue";
import AllProducts from "../views/Cruds/Products/ShowAll.vue";
import CreateProducts from "../views/Cruds/Products/Create.vue";
import ShowProducts from "../views/Cruds/Products/Show.vue";
import EditProducts from "../views/Cruds/Products/Edit.vue";
// ============== End:: Products Routes

// ============== Start:: Cities Routes
import CitiesHome from "../views/Cruds/Cities/Home.vue";
import AllCities from "../views/Cruds/Cities/ShowAll.vue";
import CreateCities from "../views/Cruds/Cities/Create.vue";
import ShowCities from "../views/Cruds/Cities/Show.vue";
import EditCities from "../views/Cruds/Cities/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: Districts Routes
import DistrictsHome from "../views/Cruds/Districts/Home.vue";
import AllDistricts from "../views/Cruds/Districts/ShowAll.vue";
import CreateDistricts from "../views/Cruds/Districts/Create.vue";
import ShowDistricts from "../views/Cruds/Districts/Show.vue";
import EditDistricts from "../views/Cruds/Districts/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: Regions Routes
import RegionsHome from "../views/Cruds/Regions/Home.vue";
import AllRegions from "../views/Cruds/Regions/ShowAll.vue";
import CreateRegions from "../views/Cruds/Regions/Create.vue";
import ShowRegions from "../views/Cruds/Regions/Show.vue";
import EditRegions from "../views/Cruds/Regions/Edit.vue";
// ============== End:: Regions Routes

// ============== Start:: EducationalQualifications Routes
import EducationalQualificationsHome from "../views/Cruds/EducationalQualifications/Home.vue";
import AllEducationalQualifications from "../views/Cruds/EducationalQualifications/ShowAll.vue";
import CreateEducationalQualifications from "../views/Cruds/EducationalQualifications/Create.vue";
import ShowEducationalQualifications from "../views/Cruds/EducationalQualifications/Show.vue";
import EditEducationalQualifications from "../views/Cruds/EducationalQualifications/Edit.vue";
// ============== End:: EducationalQualifications Routes

// ============== Start:: WorkScope Routes
import WorkScopeHome from "../views/Cruds/WorkScope/Home.vue";
import AllWorkScope from "../views/Cruds/WorkScope/ShowAll.vue";
import CreateWorkScope from "../views/Cruds/WorkScope/Create.vue";
import ShowWorkScope from "../views/Cruds/WorkScope/Show.vue";
import EditWorkScope from "../views/Cruds/WorkScope/Edit.vue";
// ============== End:: WorkScope Routes

// ============== Start:: CompanyFields Routes
import CompanyFieldsHome from "../views/Cruds/CompanyFields/Home.vue";
import AllCompanyFields from "../views/Cruds/CompanyFields/ShowAll.vue";
import CreateCompanyFields from "../views/Cruds/CompanyFields/Create.vue";
import EditCompanyFields from "../views/Cruds/CompanyFields/Edit.vue";
// ============== End:: CompanyFields Routes

// ============== Start:: WorkNature Routes
import WorkNatureHome from "../views/Cruds/WorkNature/Home.vue";
import AllWorkNature from "../views/Cruds/WorkNature/ShowAll.vue";
import CreateWorkNature from "../views/Cruds/WorkNature/Create.vue";
import ShowWorkNature from "../views/Cruds/WorkNature/Show.vue";
import EditWorkNature from "../views/Cruds/WorkNature/Edit.vue";
// ============== End:: WorkNature Routes

// ============== Start:: Specializations Routes
import SpecializationsHome from "../views/Cruds/Specializations/Home.vue";
import AllSpecializations from "../views/Cruds/Specializations/ShowAll.vue";
import CreateSpecializations from "../views/Cruds/Specializations/Create.vue";
import ShowSpecializations from "../views/Cruds/Specializations/Show.vue";
import EditSpecializations from "../views/Cruds/Specializations/Edit.vue";
// ============== End:: Specializations Routes

// ============== Start:: Services Routes
import ServicesHome from "../views/Cruds/Services/Home.vue";
import AllServices from "../views/Cruds/Services/ShowAll.vue";
import CreateServices from "../views/Cruds/Services/Create.vue";
import ShowServices from "../views/Cruds/Services/Show.vue";
import EditServices from "../views/Cruds/Services/Edit.vue";
// ============== End:: Services Routes

// ============== Start:: Questions Routes
import QuestionsHome from "../views/Cruds/Questions/Home.vue";
import AllQuestions from "../views/Cruds/Questions/ShowAll.vue";
import CreateQuestions from "../views/Cruds/Questions/Create.vue";
import ShowQuestions from "../views/Cruds/Questions/Show.vue";
import EditQuestions from "../views/Cruds/Questions/Edit.vue";
// ============== End:: Questions Routes
// ============== Start:: Workplaces Routes
import WorkplacesHome from "../views/Cruds/Workplaces/Home.vue";
import AllWorkplaces from "../views/Cruds/Workplaces/ShowAll.vue";
import CreateWorkplaces from "../views/Cruds/Workplaces/Create.vue";
import ShowWorkplaces from "../views/Cruds/Workplaces/Show.vue";
import EditWorkplaces from "../views/Cruds/Workplaces/Edit.vue";
// ============== End:: Workplaces Routes

// ============== Start:: WalletRequests Routes
import RequestWalletsHome from "../views/Cruds/WalletRequests/Home.vue";
import AllRequestWallets from "../views/Cruds/WalletRequests/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: WalletHistory Routes
import WalletHistoryHome from "../views/Cruds/WalletHistory/Home.vue";
import AllWalletHistory from "../views/Cruds/WalletHistory/ShowAll.vue";
// ============== End:: WalletRequests Routes

// ============== Start:: Reasons Routes
import ReasonsHome from "../views/Cruds/Reasons/Home.vue";
import AllReasons from "../views/Cruds/Reasons/ShowAll.vue";
import CreateReasons from "../views/Cruds/Reasons/Create.vue";
import ShowReasons from "../views/Cruds/Reasons/Show.vue";
import EditReasons from "../views/Cruds/Reasons/Edit.vue";
// ============== End:: Reasons Routes

// ============== Start:: Banks Routes
import BanksHome from "../views/Cruds/Banks/Home.vue";
import AllBanks from "../views/Cruds/Banks/ShowAll.vue";
import CreateBanks from "../views/Cruds/Banks/Create.vue";
import ShowBanks from "../views/Cruds/Banks/Show.vue";
import EditBanks from "../views/Cruds/Banks/Edit.vue";
// ============== End:: Banks Routes

// ============== Start:: Packages Routes
import PackagesHome from "../views/Cruds/Packages/Home.vue";
import AllPackages from "../views/Cruds/Packages/ShowAll.vue";
import CreatePackages from "../views/Cruds/Packages/Create.vue";
import ShowPackages from "../views/Cruds/Packages/Show.vue";
import EditPackages from "../views/Cruds/Packages/Edit.vue";
// ============== Start:: PackagesSubs Routes
import PackagesSubsHome from "../views/Cruds/PackagesSubs/Home.vue";
import AllPackagesSubs from "../views/Cruds/PackagesSubs/ShowAll.vue";
import CreatePackagesSubs from "../views/Cruds/PackagesSubs/Create.vue";
import ShowPackagesSubs from "../views/Cruds/PackagesSubs/Show.vue";
import EditPackagesSubs from "../views/Cruds/PackagesSubs/Edit.vue";
// ============== Start:: DisputedQuestions Routes
import DisputedQuestionsHome from "../views/Cruds/DisputedQuestions/Home.vue";
import AllDisputedQuestions from "../views/Cruds/DisputedQuestions/ShowAll.vue";
import CreateDisputedQuestions from "../views/Cruds/DisputedQuestions/Create.vue";
import ShowDisputedQuestions from "../views/Cruds/DisputedQuestions/Show.vue";
import EditDisputedQuestions from "../views/Cruds/DisputedQuestions/Edit.vue";
// ============== End:: Cities Routes
// ============== Start:: Badges Routes
import BadgesHome from "../views/Cruds/Badges/Home.vue";
import AllBadges from "../views/Cruds/Badges/ShowAll.vue";
import CreateBadges from "../views/Cruds/Badges/Create.vue";
import ShowBadges from "../views/Cruds/Badges/Show.vue";
import EditBadges from "../views/Cruds/Badges/Edit.vue";
// ============== End:: Cities Routes

// ============== Start:: orders Routes
import ordersHome from "../views/Cruds/Orders/Home.vue";
import Allorders from "../views/Cruds/Orders/ShowAll.vue";
import Showorders from "../views/Cruds/Orders/Show.vue";
// ============== End:: orders Routes

// ============== Start:: Cancelling orders Routes
import OrdersCancelRequestHome from "../views/Cruds/OrdersCancelRequest/Home.vue";
import AllOrdersCancelRequest from "../views/Cruds/OrdersCancelRequest/ShowAll.vue";
import ShowOrdersCancelRequest from "../views/Cruds/OrdersCancelRequest/Show.vue";
// ============== End:: Cancelling orders Routes

// ============== Start:: UserRequests Routes =================
import UserRequestsHome from "../views/Cruds/UserRequests/Home.vue";
import AllUserRequests from "../views/Cruds/UserRequests/ShowAll.vue";
import ShowUserRequests from "../views/Cruds/UserRequests/Show.vue";
// ============== Start:: UserRequests Routes =================

// ============== Start:: Providers Routes
import ProvidersHome from "../views/Cruds/Providers/Home.vue";
import AllProviders from "../views/Cruds/Providers/ShowAll.vue";
import CreateProviders from "../views/Cruds/Providers/Create.vue";
import ShowProviders from "../views/Cruds/Providers/Show.vue";
import EditProviders from "../views/Cruds/Providers/Edit.vue";
import ProviderSubscriptions from "../views/Cruds/Providers/Subscriptions.vue";
// ============== End:: Providers Routes

// ============== Start:: Join Providers Routes
import JoinProvidersHome from "../views/Cruds/JoinProviders/Home.vue";
import AllJoinProviders from "../views/Cruds/JoinProviders/ShowAll.vue";
import ShowJoinProviders from "../views/Cruds/JoinProviders/Show.vue";
// ============== End:: Join Providers Routes

// ============== Start:: Update Providers Routes
import UpdateProvidersHome from "../views/Cruds/UpdateRequestProviders/Home.vue";
import AllUpdateProviders from "../views/Cruds/UpdateRequestProviders/ShowAll.vue";
import ShowUpdateProviders from "../views/Cruds/UpdateRequestProviders/Show.vue";
// ============== End:: Updates Providers Routes

// ============== Start:: All Notifications Routes
import AllNotifications from "../views/Cruds/Notifications/ShowAll.vue";
import NotificationsHome from "../views/Cruds/Notifications/Home.vue";
import CreateNotifications from "../views/Cruds/Notifications/Create.vue";
import ShowNotificationsTable from "../views/Cruds/Notifications/Show.vue";
// import ShowNotificationsIcon from "../views/Cruds/Notifications/Test.vue";
import ShowAllNotifications from "../views/Cruds/Notifications/ShowAllNotifications.vue";

// ============== End:: All Notifications Routes

// ================== Start:: Clients Routes
import ClientsHome from "../views/Cruds/Clients/Home.vue";
import AllClients from "../views/Cruds/Clients/ShowAll.vue";
import CreateClients from "../views/Cruds/Clients/Create.vue";
import EditClients from "../views/Cruds/Clients/Edit.vue";
import ShowClients from "../views/Cruds/Clients/Show.vue";
// ================= End:: Clients Routes
// ================== Start:: discount_platforms Routes
import discount_platformsHome from "../views/Cruds/DiscountPlatforms/Home.vue";
import Alldiscount_platforms from "../views/Cruds/DiscountPlatforms/ShowAll.vue";
import Creatediscount_platforms from "../views/Cruds/DiscountPlatforms/Create.vue";
import Editdiscount_platforms from "../views/Cruds/DiscountPlatforms/Edit.vue";
import Showdiscount_platforms from "../views/Cruds/DiscountPlatforms/Show.vue";
// ================= End:: Clients Routes

// ================== Start:: ServiceProviders Routes
import ServiceProvidersHome from "../views/Cruds/ServiceProviders/Home.vue";
import AllServiceProviders from "../views/Cruds/ServiceProviders/ShowAll.vue";
import CreateServiceProviders from "../views/Cruds/ServiceProviders/Create.vue";
import EditServiceProviders from "../views/Cruds/ServiceProviders/Edit.vue";
import ShowServiceProviders from "../views/Cruds/ServiceProviders/Show.vue";
// ================= End:: ServiceProviders Routes

// ================== Start:: DiscountCards Routes
import DiscountCardsHome from "../views/Cruds/DiscountCards/Home.vue";
import AllDiscountCards from "../views/Cruds/DiscountCards/ShowAll.vue";
import CreateDiscountCards from "../views/Cruds/DiscountCards/Create.vue";
import EditDiscountCards from "../views/Cruds/DiscountCards/Edit.vue";
import ShowDiscountCards from "../views/Cruds/DiscountCards/Show.vue";
// ================= End:: DiscountCards Routes

// ================== Start:: GiftCards Routes
import GiftCardsHome from "../views/Cruds/GiftCards/Home.vue";
import AllGiftCards from "../views/Cruds/GiftCards/ShowAll.vue";
import CreateGiftCards from "../views/Cruds/GiftCards/Create.vue";
import EditGiftCards from "../views/Cruds/GiftCards/Edit.vue";
import ShowGiftCards from "../views/Cruds/GiftCards/Show.vue";
// ================= End:: GiftCards Routes

//=============== Start:: Order Desiginer Routes
import OrdersRequestsHome from "../views/Cruds/OrdersRequests/Home.vue";
import AllOrdersRequests from "../views/Cruds/OrdersRequests/ShowAll.vue";
import ShowOrdersRequests from "../views/Cruds/OrdersRequests/Show.vue";
//============== End:: Order Desiginer Routes

// ============== Start:: MainCategories Routes
import CategoriesHome from "../views/Cruds/MainCategories/Home.vue";
import AllCategories from "../views/Cruds/MainCategories/ShowAll.vue";
import CreateCategories from "../views/Cruds/MainCategories/Create.vue";
import EditCategories from "../views/Cruds/MainCategories/Edit.vue";
import ShowCategories from "../views/Cruds/MainCategories/Show.vue";
// ============== End:: MainCategories Routes

// ============== Start:: SubCategories Routes
import SubCategoriesHome from "../views/Cruds/SubCategories/Home.vue";
import AllSubCategories from "../views/Cruds/SubCategories/ShowAll.vue";
import CreateSubCategories from "../views/Cruds/SubCategories/Create.vue";
import EditSubCategories from "../views/Cruds/SubCategories/Edit.vue";
import ShowSubCategories from "../views/Cruds/SubCategories/Show.vue";
// ============== End:: SubCategories Routes
// ============== Start:: Coupons Routes
import CouponsHome from "../views/Cruds/Coupons/Home.vue";
import AllCoupons from "../views/Cruds/Coupons/ShowAll.vue";
import CreateCoupons from "../views/Cruds/Coupons/Create.vue";
import ShowCoupons from "../views/Cruds/Coupons/Show.vue";
import EditCoupons from "../views/Cruds/Coupons/Edit.vue";
// ============== End:: Coupons Routes

// ============== Start:: Capacities Routes
import CapacitiesHome from "../views/Cruds/Capacities/Home.vue";
import AllCapacities from "../views/Cruds/Capacities/ShowAll.vue";
import CreateCapacities from "../views/Cruds/Capacities/Create.vue";
import ShowCapacities from "../views/Cruds/Capacities/Show.vue";
import EditCapacities from "../views/Cruds/Capacities/Edit.vue";
// ============== End:: Capacities Routes

// ============== Start:: ResidentialAdd Routes
import ResidentialAddHome from "../views/Cruds/ResidentialAdd/Home.vue";
import AllResidentialAdd from "../views/Cruds/ResidentialAdd/ShowAll.vue";
import CreateResidentialAdd from "../views/Cruds/ResidentialAdd/Create.vue";
import ShowResidentialAdd from "../views/Cruds/ResidentialAdd/Show.vue";
import EditResidentialAdd from "../views/Cruds/ResidentialAdd/Edit.vue";
// ============== End:: ResidentialAdd Routes

// ============== Start:: Managements Routes
import ManagementsHome from "../views/Cruds/Managements/Home.vue";
import AllManagements from "../views/Cruds/Managements/ShowAll.vue";
import CreateManagements from "../views/Cruds/Managements/Create.vue";
import EditManagements from "../views/Cruds/Managements/Edit.vue";
import ShowManagements from "../views/Cruds/Managements/Show.vue";
// ============== End:: Managements Routes

// ============== Start:: Forbidden Route
import ForbiddenPage from "../pages/ForbiddenPage.vue";
// ============== End:: Forbidden Route

// ============== Start:: Not Found Route
import NotFoundPage from "../pages/NotFound.vue";
import ShowTeams from "../views/Cruds/Clients/ShowTeams.vue";
import ShowClientPackages from "../views/Cruds/Clients/ShowClientPackages.vue";
// ============== End:: Not Found Route

// End:: Importing Router Components

Vue.use(VueRouter);
const routes = [
  // ***************** Start:: Auth Routes Config
  {
    path: "/",
    component: Authentication,
    children: [
      {
        path: "/",
        component: LoginForm,
        name: "LoginForm",
      },
      {
        path: "/reset-password-email",
        name: "ResetPasswordEmailForm",
        component: ResetPasswordEmailForm,
      },
      {
        path: "/email-verification/:verification_type",
        name: "EmailVerificationForm",
        component: EmailVerificationForm,
      },
      {
        path: "/chang-phone-number",
        name: "ChangePhoneNumberForm",
        component: ChangePhoneNumberForm,
      },
      {
        path: "/reset-password",
        name: "ResetPasswordForm",
        component: ResetPasswordForm,
      },
    ],
  },
  // ***************** End:: Auth Routes Config

  // ***************** Start:: Content Routes Config
  {
    path: "/home",
    component: AppContentWrapper,
    children: [
      // Start:: Home Route Config
      {
        path: "/home",
        component: HomePage,
        meta: {
          middleware: [auth],
        },
      },
      // End:: Home Route Config

      // Start:: Contact Messages Routes Config
      {
        path: "/contact-messages",
        name: "ContactMessagesHome",
        component: ContactMessagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllContactMessages",
            component: AllContactMessages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts index",
                subject: "contacts",
              },
            },
          },
          {
            path: "show/:id",
            name: "showMessage",
            component: showMessage,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "contacts show",
                subject: "contacts",
              },
            },
          },
        ],
      },
      // End:: Contact Messages Routes Config

      // Start:: App Content Routes Config
      {
        path: "/app-content",
        name: "AppContentHome",
        component: AppContentHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "contact-us",
            name: "ContactUs",
            component: ContactUs,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "about-us-client",
            name: "AboutUsClient",
            component: AboutUsClient,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "about-us-provider",
            name: "AboutUsProvider",
            component: AboutUsProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "terms-client",
            name: "TermsClient",
            component: TermsClient,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "terms-provider",
            name: "TermsProvider",
            component: TermsProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "policy-client",
            name: "PrivacyPolicyClient",
            component: PrivacyPolicyClient,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "policy-provider",
            name: "PrivacyPolicyProvider",
            component: PrivacyPolicyProvider,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings create",
                subject: "settings",
              },
            },
          },
          {
            path: "delete-account",
            name: "DeleteAccount",
            component: DeleteAccount,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "settings edit",
                subject: "settings",
              },
            },
          },
        ],
      },
      // End:: App Content Routes Config

      // Start:: AllFinancialOrders Routes Config
      // {
      //   path: "/financialorders",
      //   name: "FinancialOrdersHome",
      //   component: FinancialOrdersHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialOrders",
      //       component: AllFinancialOrders,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "role index",
      //           subject: "role",
      //         },
      //       },
      //     },
      //   ],
      // },
      {
        path: "/subscriptions",
        name: "Subscriptions",
        component: SubscriptionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSubscriptions",
            component: AllSubscriptions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subscriptions index",
                subject: "subscriptions",
              },
            },
          },
        ],
      },

      // Start:: Financial Reports Routes Config
      {
        path: "/financial-reports",
        name: "FinancialReportsHome",
        component: FinancialReportsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFinancialReports",
            component: AllFinancialReports,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "financial reports index",
                subject: "financial_reports",
              },
            },
          },
        ],
      },

      // {
      //   path: "/financial-finished-reports",
      //   name: "FinancialFinshedReportsHome",
      //   component: FinancialFinshedReportsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllFinancialFinshedReports",
      //       component: AllFinancialFinshedReports,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "financial_reports finishedordersreports",
      //           subject: "financial_reports",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Financial Reports Routes Config

      // Start:: Roles Routes Config
      {
        path: "/roles",
        name: "RolesHome",
        component: RolesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRoles",
            component: AllRoles,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles index",
                subject: "roles",
              },
            },
          },
          {
            path: "create",
            name: "CreateRole",
            component: CreateRole,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles create",
                subject: "roles",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRole",
            component: EditRole,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "roles edit",
                subject: "roles",
              },
            },
          },
        ],
      },
      // End:: Roles Routes Config

      // Start:: Admins Routes Config
      {
        path: "/admins",
        name: "AdminsHome",
        component: AdminsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdmins",
            component: AllAdmins,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins index",
                subject: "admins",
              },
            },
          },
          {
            path: "create",
            name: "CreateAdmin",
            component: CreateAdmin,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins create",
                subject: "admins",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAdmin",
            component: EditAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins edit",
                subject: "admins",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAdmin",
            component: ShowAdmin,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "admins show",
                subject: "admins",
              },
            },
          },
        ],
      },
      // End:: Admins Routes Config

      // Start:: users Routes Config
      {
        path: "/users",
        name: "UsersHome",
        component: UsersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUsers",
            component: AllUsers,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowUsers",
            component: ShowUsers,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users show",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: users Routes Config

      // Start:: Games Routes Config
      {
        path: "/games",
        name: "GamesHome",
        component: GamesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllGames",
            component: AllGames,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "games index",
                subject: "games",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowGames",
            component: ShowGames,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "games show",
                subject: "games",
              },
            },
          },
        ],
      },
      // End:: Games Routes Config

      // Start:: products  Config
      // {
      //   path: "/products",
      //   name: "products",
      //   component: ProductsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allproducts",
      //       component: AllProducts,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products index",
      //           subject: "products",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Createproducts",
      //       component: CreateProducts,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products create",
      //           subject: "products",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editproducts",
      //       component: EditProducts,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products edit",
      //           subject: "products",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showproducts",
      //       component: ShowProducts,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "products show",
      //           subject: "products",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: products Config

      // Start:: orders  Config
      {
        path: "/orders",
        name: "orders",
        component: ordersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allorders",
            component: Allorders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders index",
                subject: "orders",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showorders",
            component: Showorders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders show",
                subject: "orders",
              },
            },
          },
        ],
      },
      // End:: orders Config
      // Start:: OrdersCancelRequest  Config
      {
        path: "/request_cancellation",
        name: "OrdersCancelRequest",
        component: OrdersCancelRequestHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllOrdersCancelRequest",
            component: AllOrdersCancelRequest,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders acceptorrejectcancellation",
                subject: "orders",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowOrdersCancelRequest",
            component: ShowOrdersCancelRequest,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "orders acceptorrejectcancellation",
                subject: "orders",
              },
            },
          },
        ],
      },
      // End:: orders Config

      // Start:: cities  Config
      {
        path: "/cities",
        name: "cities",
        component: CitiesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allcities",
            component: AllCities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities index",
                subject: "cities",
              },
            },
          },
          {
            path: "create",
            name: "Createcities",
            component: CreateCities,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities create",
                subject: "cities",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editcities",
            component: EditCities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities edit",
                subject: "cities",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showcities",
            component: ShowCities,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "cities show",
                subject: "cities",
              },
            },
          },
        ],
      },
      // End:: cities Config

      // Start:: districts  Config
      {
        path: "/districts",
        name: "districts",
        component: DistrictsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Alldistricts",
            component: AllDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "neighborhoods index",
                subject: "neighborhoods",
              },
            },
          },
          {
            path: "create",
            name: "Createdistricts",
            component: CreateDistricts,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "neighborhoods create",
                subject: "neighborhoods",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editdistricts",
            component: EditDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "neighborhoods edit",
                subject: "neighborhoods",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showdistricts",
            component: ShowDistricts,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "neighborhoods show",
                subject: "neighborhoods",
              },
            },
          },
        ],
      },
      // End:: districts Config

      // Start:: RegionsHome  Config
      {
        path: "/regions",
        name: "regions",
        component: RegionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRegions",
            component: AllRegions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions index",
                subject: "regions",
              },
            },
          },
          {
            path: "create",
            name: "CreateRegions",
            component: CreateRegions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions create",
                subject: "regions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditRegions",
            component: EditRegions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions edit",
                subject: "regions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowRegions",
            component: ShowRegions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "regions show",
                subject: "regions",
              },
            },
          },
        ],
      },
      // End:: Regions

      // Start:: Coupons  Config
      {
        path: "/coupons",
        name: "coupons",
        component: CouponsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCoupons",
            component: AllCoupons,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "coupons index",
                subject: "coupons",
              },
            },
          },
          {
            path: "create",
            name: "CreateCoupons",
            component: CreateCoupons,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "coupons create",
                subject: "coupons",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCoupons",
            component: EditCoupons,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "coupons edit",
                subject: "coupons",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCoupons",
            component: ShowCoupons,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "coupons show",
                subject: "coupons",
              },
            },
          },
        ],
      },
      // End:: Coupons

      // Start:: educationalqualification  Config
      {
        path: "/educational-qualification",
        name: "educational",
        component: EducationalQualificationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllEducationalQualifications",
            component: AllEducationalQualifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "educationalqualification index",
                subject: "educationalqualification",
              },
            },
          },
          {
            path: "create",
            name: "CreateEducationalQualifications",
            component: CreateEducationalQualifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "educationalqualification create",
                subject: "educationalqualification",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditEducationalQualifications",
            component: EditEducationalQualifications,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "educationalqualification edit",
                subject: "educationalqualification",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowEducationalQualifications",
            component: ShowEducationalQualifications,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "educationalqualification show",
                subject: "educationalqualification",
              },
            },
          },
        ],
      },
      // End:: educationalqualification

      // Start:: WorkScope  Config
      {
        path: "/work-scope",
        name: "scope",
        component: WorkScopeHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllWorkScopes",
            component: AllWorkScope,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework index",
                subject: "scopework",
              },
            },
          },
          {
            path: "create",
            name: "CreateWorkScopes",
            component: CreateWorkScope,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework create",
                subject: "scopework",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditWorkScopes",
            component: EditWorkScope,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework edit",
                subject: "scopework",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowWorkScopes",
            component: ShowWorkScope,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework show",
                subject: "scopework",
              },
            },
          },
        ],
      },
      // End:: WorkScope Config

      // Start:: CompanyFields  Config
      {
        path: "/company-fields",
        name: "companyFields",
        component: CompanyFieldsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCompanyFields",
            component: AllCompanyFields,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "companyfield index",
                subject: "companyfield",
              },
            },
          },
          {
            path: "create",
            name: "CreateCompanyFields",
            component: CreateCompanyFields,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "companyfield create",
                subject: "companyfield",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCompanyFields",
            component: EditCompanyFields,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "companyfield edit",
                subject: "companyfield",
              },
            },
          },
        ],
      },
      // End:: CompanyFields Config

      // Start:: services  Config
      // {
      //   path: "/services",
      //   name: "services",
      //   component: ServicesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allservices",
      //       component: AllServices,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "services index",
      //           subject: "services",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Createservices",
      //       component: CreateServices,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "services create",
      //           subject: "services",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editservices",
      //       component: EditServices,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "services edit",
      //           subject: "services",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showservices",
      //       component: ShowServices,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "services show",
      //           subject: "services",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: services Config

      // Start:: reasons  Config
      {
        path: "/reasons",
        name: "reasons",
        component: ReasonsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allreasons",
            component: AllReasons,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons index",
                subject: "reasons",
              },
            },
          },
          {
            path: "create",
            name: "Createreasons",
            component: CreateReasons,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons create",
                subject: "reasons",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editreasons",
            component: EditReasons,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons edit",
                subject: "reasons",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showreasons",
            component: ShowReasons,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "reasons show",
                subject: "reasons",
              },
            },
          },
        ],
      },
      // End:: reasons Config

      // Start:: workplaces  Config
      // {
      //   path: "/workplaces",
      //   name: "workplaces",
      //   component: WorkplacesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Allworkplaces",
      //       component: AllWorkplaces,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces index",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Createworkplaces",
      //       component: CreateWorkplaces,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces create",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editworkplaces",
      //       component: EditWorkplaces,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces edit",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showworkplaces",
      //       component: ShowWorkplaces,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "workplaces show",
      //           subject: "workplaces",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: workplaces Config

      // End:: Questions Config

      {
        path: "/questions",
        name: "Questions",
        component: QuestionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllQuestions",
            component: AllQuestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "Questions index",
                subject: "Questions",
              },
            },
          },
          {
            path: "create",
            name: "CreateQuestions",
            component: CreateQuestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "Questions create",
                subject: "Questions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditQuestions",
            component: EditQuestions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "Questions edit",
                subject: "Questions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowQuestions",
            component: ShowQuestions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "Questions show",
                subject: "Questions",
              },
            },
          },
        ],
      },
      // End:: Questions Config

      // Start:: WalletRequests  Config
      {
        path: "/request-wallets",
        name: "RequestWallets",
        component: RequestWalletsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllRequestWallets",
            component: AllRequestWallets,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "withdraw requests index",
                subject: "withdraw_requests",
              },
            },
          },
        ],
      },
      // End:: WalletRequests Config

      // start::designers orders
      // {
      //   path: "/user-requests",
      //   name: "UserRequestsHome",
      //   component: UserRequestsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllUserRequests",
      //       component: AllUserRequests,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "acceptedproviders index",
      //           subject: "acceptedproviders",
      //         },
      //       },
      //     },

      //     {
      //       path: "show/:id",
      //       name: "ShowUserRequests",
      //       component: ShowUserRequests,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "acceptedproviders show",
      //           subject: "acceptedproviders",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End::designers orders

      // Start:: WalletHistory  Config
      // {
      //   path: "/WalletHistory",
      //   name: "WalletHistory",
      //   component: WalletHistoryHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all/:id",
      //       name: "AllWalletHistory",
      //       component: AllWalletHistory,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "users index",
      //           subject: "users",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: WalletHistory Config

      // Start:: Providers  Config
      {
        path: "/providers",
        name: "Providers",
        component: ProvidersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllProviders",
            component: AllProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers index",
                subject: "providers",
              },
            },
          },
          {
            path: "create",
            name: "CreateProviders",
            component: CreateProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers create",
                subject: "providers",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditProviders",
            component: EditProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers edit",
                subject: "providers",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowProviders",
            component: ShowProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers show",
                subject: "providers",
              },
            },
          },
          {
            path: "subscriptions/:id",
            name: "ProviderSubscriptions",
            component: ProviderSubscriptions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "providers show",
                subject: "providers",
              },
            },
          },
        ],
      },
      // End:: Providers Config
      // Start:: Join Providers Config
      {
        path: "/join-providers",
        name: "JoinProviders",
        component: JoinProvidersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllJoinProviders",
            component: AllJoinProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "provider joining index",
                subject: "provider_joining",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowJoinProviders",
            component: ShowJoinProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "provider joining show",
                subject: "provider_joining",
              },
            },
          },
        ],
      },
      // End:: Join Providers Config
      // Start:: Update Providers Config
      {
        path: "/provider-update-requests",
        name: "UpdateProvidersHome",
        component: UpdateProvidersHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllUpdateProviders",
            component: AllUpdateProviders,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "update salon requests index",
                subject: "update_salon_requests",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowUpdateProviders",
            component: ShowUpdateProviders,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "update salon requests show",
                subject: "update_salon_requests",
              },
            },
          },
        ],
      },
      // End:: Join Providers Config

      // Start:: banks  Config
      {
        path: "/banks",
        name: "banks",
        component: BanksHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allbanks",
            component: AllBanks,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks index",
                subject: "banks",
              },
            },
          },
          {
            path: "create",
            name: "Createbanks",
            component: CreateBanks,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks create",
                subject: "banks",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editbanks",
            component: EditBanks,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks edit",
                subject: "banks",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showbanks",
            component: ShowBanks,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "banks show",
                subject: "banks",
              },
            },
          },
        ],
      },
      // End:: banks Config

      // Start:: badges  Config
      {
        path: "/badges",
        name: "badges",
        component: PackagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllBadges",
            component: AllBadges,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "badge index",
                subject: "badge",
              },
            },
          },
          {
            path: "create",
            name: "CreateBadges",
            component: CreateBadges,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "badge create",
                subject: "badge",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditBadges",
            component: EditBadges,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "badge edit",
                subject: "badge",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowBadges",
            component: ShowBadges,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "badge show",
                subject: "badge",
              },
            },
          },
        ],
      },
      // End:: badges Config
      // Start:: packages  Config
      {
        path: "/packages",
        name: "packages",
        component: PackagesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "Allpackages",
            component: AllPackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "package index",
                subject: "package",
              },
            },
          },
          {
            path: "create",
            name: "Createpackages",
            component: CreatePackages,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "package create",
                subject: "package",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editpackages",
            component: EditPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages edit",
                subject: "packages",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showpackages",
            component: ShowPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "packages show",
                subject: "packages",
              },
            },
          },
        ],
      },
      // End:: packages Config
      // Start:: subscription packages  Config
      {
        path: "/packages-subscriptions",
        name: "packages-subscriptions",
        component: PackagesSubsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllPackagesSubs",
            component: AllPackagesSubs,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subscription packages index",
                subject: "subscription_packages",
              },
            },
          },
          {
            path: "create",
            name: "CreatePackagesSubs",
            component: CreatePackagesSubs,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subscription packages create",
                subject: "subscription_packages",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditPackagesSubs",
            component: EditPackagesSubs,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subscription packages edit",
                subject: "subscription_packages",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowPackagesSubs",
            component: ShowPackagesSubs,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "subscription packages show",
                subject: "subscription_packages",
              },
            },
          },
        ],
      },
      // End:: subscription packages Config
      // Start:: DisputedQuestions  Config
      {
        path: "/disputed-questions",
        name: "disputed-questions",
        component: DisputedQuestionsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllDisputedQuestions",
            component: AllDisputedQuestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions index",
                subject: "questions",
              },
            },
          },
          {
            path: "create",
            name: "CreateDisputedQuestions",
            component: CreateDisputedQuestions,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions create",
                subject: "questions",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditDisputedQuestions",
            component: EditDisputedQuestions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions edit",
                subject: "questions",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowDisputedQuestions",
            component: ShowDisputedQuestions,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "questions show",
                subject: "questions",
              },
            },
          },
        ],
      },
      // End:: packages Config
      // Start:: advertisement  Config
      {
        path: "/advertisement",
        name: "advertisement",
        component: AdvertisementHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAdvertisement",
            component: AllAdvertisement,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements index",
                subject: "advertisements",
              },
            },
          },
          {
            path: "create",
            name: "CreateAdvertisement",
            component: CreateAdvertisement,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements create",
                subject: "advertisements",
              },
            },
          },
          // {
          //   path: "edit/:id",
          //   name: "EditAdvertisement",
          //   component: EditAdvertisement,
          //   props: true,
          //   meta: {
          //     middleware: [auth],
          //     requiresPermission: {
          //       action: "advertisements edit",
          //       subject: "advertisements",
          //     },
          //   },
          // },
          {
            path: "show/:id",
            name: "ShowAdvertisement",
            component: ShowAdvertisement,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements show",
                subject: "advertisements",
              },
            },
          },
        ],
      },
      // End:: advertisement Config
      // Start:: ads  Config
      {
        path: "/ads",
        name: "ads",
        component: AdsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllAds",
            component: AllAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements index",
                subject: "advertisements",
              },
            },
          },
          {
            path: "create",
            name: "CreateAds",
            component: CreateAds,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements create",
                subject: "advertisements",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditAds",
            component: EditAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements edit",
                subject: "advertisements",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowAds",
            component: ShowAds,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "advertisements show",
                subject: "advertisements",
              },
            },
          },
        ],
      },
      // End:: ads Config

      // Start:: All Notifications Route Config
      {
        path: "/all-notifications",
        name: "NotificationsHome",
        component: NotificationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllNotifications",
            component: AllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "create",
            name: "CreateNotificationss",
            component: CreateNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications create",
                subject: "notifications",
              },
            },
          },
          {
            path: "show",
            name: "ShowAllNotifications",
            component: ShowAllNotifications,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowNotificationss",
            component: ShowNotificationsTable,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "notifications index",
                subject: "notifications",
              },
            },
          },
        ],
      },
      // End:: All Notifications Route Config

      // Start:: GiftCardsHome Routes Config
      // {
      //   path: "/gift-cards",
      //   name: "GiftCardsHome",
      //   component: GiftCardsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllGiftCards",
      //       component: AllGiftCards,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "giftcardtypes index",
      //           subject: "giftcardtypes",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditGiftCards",
      //       component: EditGiftCards,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "giftcardtypes edit",
      //           subject: "giftcardtypes",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowGiftCards",
      //       component: ShowGiftCards,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "giftcardtypes show",
      //           subject: "giftcardtypes",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateGiftCards",
      //       component: CreateGiftCards,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "giftcardtypes create",
      //           subject: "giftcardtypes",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: GiftCardsHome Routes Config

      // Start:: DiscountCardsHome Routes Config
      // {
      //   path: "/discount-cards",
      //   name: "DiscountCardsHome",
      //   component: DiscountCardsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllDiscountCards",
      //       component: AllDiscountCards,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountcardtypes index",
      //           subject: "discountcardtypes",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditDiscountCards",
      //       component: EditDiscountCards,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountcardtypes edit",
      //           subject: "discountcardtypes",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowDiscountCards",
      //       component: ShowDiscountCards,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountcardtypes show",
      //           subject: "discountcardtypes",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateDiscountCards",
      //       component: CreateDiscountCards,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountcardtypes create",
      //           subject: "discountcardtypes",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: DiscountCardsHome Routes Config

      // // Start:: ServiceProviders Routes Config
      // {
      //   path: "/service-providers",
      //   name: "ServiceProvidersHome",
      //   component: ServiceProvidersHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllServiceProviders",
      //       component: AllServiceProviders,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "vendor index",
      //           subject: "vendor",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditServiceProviders",
      //       component: EditServiceProviders,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "vendor edit",
      //           subject: "vendor",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowServiceProviders",
      //       component: ShowServiceProviders,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "vendor show",
      //           subject: "vendor",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateServiceProviders",
      //       component: CreateServiceProviders,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "vendor create",
      //           subject: "vendor",
      //         },
      //       },
      //     },
      //   ],
      // },
      // // End:: ServiceProviders Routes Config

      // Start:: companies Routes Config
      {
        path: "/companies-joining-requests",
        name: "CompaniesRequestsHome",
        component: CompaniesRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCompaniesRequests",
            component: AllCompaniesRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "company index",
                subject: "company",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCompaniesRequests",
            component: ShowCompaniesRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "company show",
                subject: "company",
              },
            },
          },
        ],
      },
      // End:: companies Routes Config

      // Start:: Clients Routes Config
      // {
      //   path: "/discount_platforms",
      //   name: "discount_platformsHome",
      //   component: discount_platformsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "Alldiscount_platforms",
      //       component: Alldiscount_platforms,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountplatform index",
      //           subject: "discountplatform",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "Editdiscount_platforms",
      //       component: Editdiscount_platforms,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountplatform edit",
      //           subject: "discountplatform",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "Showdiscount_platforms",
      //       component: Showdiscount_platforms,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountplatform show",
      //           subject: "discountplatform",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "Creatediscount_platforms",
      //       component: Creatediscount_platforms,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "discountplatform create",
      //           subject: "discountplatform",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Clients Routes Config
      // Start:: Clients Routes Config
      {
        path: "/Clients",
        name: "ClientsHome",
        component: ClientsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllClients",
            component: AllClients,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "client index",
                subject: "client",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditClients",
            component: EditClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "client edit",
                subject: "client",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowClients",
            component: ShowClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "client show",
                subject: "client",
              },
            },
          },
          {
            path: `show/:id/teams`,
            name: "ShowClients",
            component: ShowTeams,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "client show",
                subject: "client",
              },
            },
          },
          {
            path: `show/:id/packages`,
            name: "ShowClients",
            component: ShowClientPackages,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "client show",
                subject: "client",
              },
            },
          },
          {
            path: "create",
            name: "CreateClients",
            component: CreateClients,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "client create",
                subject: "client",
              },
            },
          },
        ],
      },
      // End:: Clients Routes Config
      // Start:: WorkScope  Config
      {
        path: "/work-scope",
        name: "scope",
        component: WorkScopeHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllWorkScopes",
            component: AllWorkScope,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework index",
                subject: "scopework",
              },
            },
          },
          {
            path: "create",
            name: "CreateWorkScopes",
            component: CreateWorkScope,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework create",
                subject: "scopework",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditWorkScopes",
            component: EditWorkScope,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework edit",
                subject: "scopework",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowWorkScopes",
            component: ShowWorkScope,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "scopework show",
                subject: "scopework",
              },
            },
          },
        ],
      },
      // End:: WorkScope Config

      // Start:: Specializations  Config
      {
        path: "/specialization",
        name: "scope",
        component: SpecializationsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllSpecializations",
            component: AllSpecializations,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "specialization index",
                subject: "specialization",
              },
            },
          },
          {
            path: "create",
            name: "CreateSpecialization",
            component: CreateSpecializations,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "specialization create",
                subject: "specialization",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditSpecialization",
            component: EditSpecializations,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "specialization edit",
                subject: "specialization",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowSpecialization",
            component: ShowSpecializations,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "specialization show",
                subject: "specialization",
              },
            },
          },
        ],
      },
      // End:: WorkScope Config

      // Start:: WokrNature  Config
      {
        path: "/work-nature",
        name: "worknature",
        component: WorkNatureHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllWorkNature",
            component: AllWorkNature,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "worknature index",
                subject: "worknature",
              },
            },
          },
          {
            path: "create",
            name: "CreateWorkNature",
            component: CreateWorkNature,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "worknature create",
                subject: "worknature",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditWorkNatures",
            component: EditWorkNature,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "worknature edit",
                subject: "worknature",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowWorkNatures",
            component: ShowWorkNature,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "worknature show",
                subject: "worknature",
              },
            },
          },
        ],
      },
      // End:: WorkScope Config
      // Start:: Companies Routes Config
      {
        path: "/companies",
        name: "CompaniesHome",
        component: CompaniesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCompanies",
            component: AllCompanies,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "company index",
                subject: "company",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCompanies",
            component: EditCompanies,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "company edit",
                subject: "company",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCompanies",
            component: ShowCompany,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "company show",
                subject: "company",
              },
            },
          },
          {
            path: "create",
            name: "CreateCompanies",
            component: CreateCompanies,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "company create",
                subject: "company",
              },
            },
          },
        ],
      },
      // End:: Companies Routes Config

      // Start:: Order requests config
      {
        path: "/order-requests",
        name: "OrdersRequestsHome",
        component: OrdersRequestsHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllOrdersRequests",
            component: AllOrdersRequests,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowOrdersRequests",
            component: ShowOrdersRequests,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "users index",
                subject: "users",
              },
            },
          },
        ],
      },
      // End:: Order requests config

      // Start:: questions Routes Config
      {
        path: "/faqs",
        name: "FAQSHome",
        component: FAQSHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllFAQS",
            component: AllFAQS,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "faqs index",
                subject: "faqs",
              },
            },
          },
          {
            path: "create",
            name: "Createfaqs",
            component: CreateFAQS,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "faqs create",
                subject: "faqs",
              },
            },
          },
          {
            path: "edit/:id",
            name: "Editfaqs",
            component: EditFAQS,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "faqs edit",
                subject: "faqs",
              },
            },
          },
          {
            path: "show/:id",
            name: "Showfaqs",
            component: ShowFAQS,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "faqquestions show",
                subject: "faqquestions",
              },
            },
          },
        ],
      },
      // End:: questions Routes Config

      // Start:: Categories Routes Config
      {
        path: "/categories",
        name: "CategoriesHome",
        component: CategoriesHome,
        meta: {
          middleware: [auth],
        },
        children: [
          {
            path: "all",
            name: "AllCategories",
            component: AllCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "create",
            name: "CreateCategories",
            component: CreateCategories,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "edit/:id",
            name: "EditCategories",
            component: EditCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
          {
            path: "show/:id",
            name: "ShowCategories",
            component: ShowCategories,
            props: true,
            meta: {
              middleware: [auth],
              requiresPermission: {
                action: "categories index",
                subject: "categories",
              },
            },
          },
        ],
      },
      // End:: Categories Routes Config

      // Start:: app-rates Routes Config
      // {
      //   path: "/app-rate",
      //   name: "AppRatesHome",
      //   component: AppRatesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllAppRates",
      //       component: AllAppRates,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "rates index",
      //           subject: "rates",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: app-rates Routes Config

      // Start:: app-rates Routes Config
      // {
      //   path: "/store-rate",
      //   name: "StoreRatesHome",
      //   component: StoreRatesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllStoreRates",
      //       component: AllStoreRates,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "rates index",
      //           subject: "rates",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: app-rates Routes Config

      // Start:: sub Categories Routes Config
      // {
      //   path: "/sub-categories",
      //   name: "CategoriesHome",
      //   component: SubCategoriesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllSubCategories",
      //       component: AllSubCategories,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "subcategories index",
      //           subject: "subcategories",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateSubCategories",
      //       component: CreateSubCategories,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "subcategories index",
      //           subject: "subcategories",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditSubCategories",
      //       component: EditSubCategories,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowSubCategories",
      //       component: ShowSubCategories,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "subcategories index",
      //           subject: "subcategories",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: sub Categories Routes Config

      // Start:: management Routes Config
      // {
      //   path: "/managements",
      //   name: "ManagementsHome",
      //   component: ManagementsHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllManagements",
      //       component: AllManagements,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "management index",
      //           subject: "management",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateManagements",
      //       component: CreateManagements,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "management index",
      //           subject: "management",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditManagements",
      //       component: EditManagements,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowManagements",
      //       component: ShowManagements,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "management index",
      //           subject: "management",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: management Routes Config

      // Start:: Capacities  Config
      // {
      //   path: "/Capacities",
      //   name: "CapacitiesHome",
      //   component: CapacitiesHome,
      //   meta: {
      //     middleware: [auth],
      //   },
      //   children: [
      //     {
      //       path: "all",
      //       name: "AllCapacitiesHome",
      //       component: AllCapacities,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities index",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //     {
      //       path: "create",
      //       name: "CreateCapacities",
      //       component: CreateCapacities,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities create",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //     {
      //       path: "edit/:id",
      //       name: "EditCapacities",
      //       component: EditCapacities,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities edit",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //     {
      //       path: "show/:id",
      //       name: "ShowCapacities",
      //       component: ShowCapacities,
      //       props: true,
      //       meta: {
      //         middleware: [auth],
      //         requiresPermission: {
      //           action: "capacities show",
      //           subject: "capacities",
      //         },
      //       },
      //     },
      //   ],
      // },
      // End:: Capacities Config

      // Start:: App contact Routes Config
      {
        path: "/contact_settings",
        component: ContactMessagesHome,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings create",
            subject: "settings",
          },
        },
      },
      {
        path: "/app_settings",
        component: GeneralSettings,
        meta: {
          middleware: [auth],
          requiresPermission: {
            action: "settings index",
            subject: "settings",
          },
        },
      },
      // End:: App contact Routes Config
    ],
  },
  // ***************** End:: Content Routes Config

  // ***************** Start:: Forbidden Route Config
  {
    path: "/forbidden",
    name: "ForbiddenPage",
    component: ForbiddenPage,
  },
  // ***************** End:: Forbidden Route Config

  // ***************** Start:: Not Found Route Config
  {
    path: "/:notFound(.*)",
    name: "NotFoundPage",
    component: NotFoundPage,
  },
  // ***************** End:: Not Found Route Config
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    if (to.hash) {
      return {
        selector: to.hash,
      };
    }
  },
  routes,
});

// Start:: Middleware And Router Guards
function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index];
  if (!subsequentMiddleware) return context.next;

  return (...parameters) => {
    context.next(...parameters);
    const nextMiddleware = nextFactory(context, middleware, index + 1);
    subsequentMiddleware({ ...context, next: nextMiddleware });
  };
}

// Authentication and Permission Check Middleware
router.beforeEach((to, from, next) => {
  const isAuthenticated = localStorage.getItem("glow_up_dashboard_user_token");

  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware)
      ? to.meta.middleware
      : [to.meta.middleware];
    const context = { from, next, router, to };
    const nextMiddleware = nextFactory(context, middleware, 1);
    return middleware[0]({ ...context, next: nextMiddleware });
  } else if (isAuthenticated) {
    const publicRoutes = [
      "LoginForm",
      "ResetPasswordEmailForm",
      "PhoneVerification",
      "ChangePhoneNumberForm",
      "ResetPasswordForm",
    ];

    if (publicRoutes.includes(to.name)) {
      return next("/home");
    }
  }

  if (to.meta.requiresPermission) {
    const { action, subject } = to.meta.requiresPermission;
    const storedPermissions = JSON.parse(
      localStorage.getItem("glow_up_roles")
    )?.permissions;

    if (
      storedPermissions &&
      storedPermissions.some(
        (permission) =>
          permission.action === action && permission.subject === subject
      )
    ) {
      return next();
    } else {
      return next("/forbidden");
    }
  }

  return next();
});

export default router;
